import type React from 'react';
import { useState } from 'react';

import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import TMXAccordion from 'components/accordion/TMXAccordion';
import { BodyRegular } from 'components/typography/Typography';

import ParticipantsNamesGrid, { type ParticipantsNamesGridProps } from './ParticipantsNamesGrid';

const CollapsableParticipantGrid: React.FC<ParticipantsNamesGridProps> = (props) => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();
  return (
    <TMXAccordion
      unmountOnClose
      accordionSummaryChildren={
        <Grid container alignItems="center" direction="row" gap={1}>
          <Grid item display="flex" flex={1}>
            <BodyRegular>{t('recipientsSelected', { count: props.participants.length })}</BodyRegular>
          </Grid>
          <Grid item paddingRight={1}>
            <BodyRegular>{t('showHideRecipients', { showOrHide: expanded ? 'hide' : 'show' })}</BodyRegular>
          </Grid>
        </Grid>
      }
      color="secondary"
      id="collapsable-participant-grid"
      onChange={(_e, isExpanded) => setExpanded(isExpanded)}
    >
      <Grid container>
        <ParticipantsNamesGrid {...props} />
      </Grid>
    </TMXAccordion>
  );
};

export default CollapsableParticipantGrid;
